var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dl',{staticClass:"home"},[_c('dt',[_vm._v(" "+_vm._s(_vm._f("teamName")(_vm.team))+" ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('dd',[_c('span',{staticClass:"ib"},[_c('img',{staticStyle:{"width":"9px","margin-top":"-3px"},attrs:{"src":require("@/assets/img/ico/ico_secret.png")}})])])
}]

export { render, staticRenderFns }